import PropertyMediaBoard from "../../../shared/propertyMediaManager/PropertyMediaBoard";

function CreateStepMedia({
  active,
  serverPhotos,
  serverPlans,
  photos,
  plans,
  onAddPhotos,
  onRemovePhoto,
  onDeleteServerPhoto,
  onMakeServerPhotoMain,
  onMakePendingPhotoMain,
  pendingMainLocalId,
  pendingMainServerAssignment = null,
  onRetryPendingMainAssignment,
  onAddPlans,
  onRemovePlan,
  onDeleteServerPlan,
  onReorderPhotos,
  onReorderPlans,
  photosReorderError = null,
  plansReorderError = null,
  canReorder = false,
  onEditItem,
  editingItem,
  onApplyEdit,
  onCancelEdit,
  onRetryPrepare,
  onRetryUpload,
  onReplaceServer,
  videoUrl,
  onVideoUrlChange,
  mediaBusy,
}) {
  const mainAssignmentBlocked = Boolean(
    pendingMainServerAssignment
    && (pendingMainServerAssignment.status === "patch_failed"
      || pendingMainServerAssignment.status === "refresh_failed"),
  );

  return (
    <section
      className={active ? "ap-pane is-active" : "ap-pane"}
      data-pane="5"
      aria-labelledby="ap-pane-5"
      hidden={!active}
    >
      <header className="ap-pane__head">
        <h2 id="ap-pane-5">
          <i className="fa-solid fa-camera" aria-hidden="true" />
          Фото та планування
        </h2>
        <p>
          Додайте світлини. Можна обрати головне фото; якщо не оберете — перше
          успішно завантажене стане головним.
        </p>
      </header>

      {mainAssignmentBlocked ? (
        <div
          className="ap-alert ap-alert--warning"
          role="alert"
          data-testid="pending-main-assignment-alert"
        >
          <p>
            {pendingMainServerAssignment.status === "refresh_failed"
              ? "Головне фото призначено, але список медіа не оновлено."
              : "Не вдалося призначити головне фото."}
          </p>
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            data-testid="retry-pending-main-assignment"
            disabled={mediaBusy}
            onClick={() => onRetryPendingMainAssignment?.()}
          >
            Повторити призначення головного
          </button>
        </div>
      ) : null}

      <PropertyMediaBoard
        kind="image"
        title="Фото об'єкта"
        dropTitle="Перетягніть фото сюди або натисніть, щоб обрати"
        inputId="ap-photos"
        serverItems={serverPhotos}
        localItems={photos}
        busy={mediaBusy}
        canReorder={canReorder}
        allowMakeMain
        showPendingMain
        pendingMainLocalId={pendingMainLocalId}
        reorderError={photosReorderError}
        onAdd={onAddPhotos}
        onReorder={onReorderPhotos}
        onMakeMain={onMakeServerPhotoMain}
        onMakePendingMain={onMakePendingPhotoMain}
        onDeleteServer={onDeleteServerPhoto}
        onDeleteLocal={onRemovePhoto}
        onRetryPrepare={onRetryPrepare}
        onRetryUpload={onRetryUpload}
        onEditItem={onEditItem}
        editingItem={editingItem}
        onApplyEdit={onApplyEdit}
        onCancelEdit={onCancelEdit}
        onReplaceServer={onReplaceServer}
      />

      <PropertyMediaBoard
        kind="plan"
        title="Планування"
        dropTitle="Перетягніть план сюди або натисніть, щоб обрати"
        inputId="ap-plans"
        serverItems={serverPlans}
        localItems={plans}
        busy={mediaBusy}
        canReorder={canReorder}
        allowMakeMain={false}
        showPendingMain={false}
        reorderError={plansReorderError}
        onAdd={onAddPlans}
        onReorder={onReorderPlans}
        onDeleteServer={onDeleteServerPlan}
        onDeleteLocal={onRemovePlan}
        onRetryPrepare={onRetryPrepare}
        onRetryUpload={onRetryUpload}
        onEditItem={onEditItem}
        editingItem={editingItem}
        onApplyEdit={onApplyEdit}
        onCancelEdit={onCancelEdit}
        onReplaceServer={onReplaceServer}
      />

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <label htmlFor="prop-video">
            <i
              className="fa-brands fa-youtube visibility-icon"
              aria-hidden="true"
            />
            Відео (YouTube)
          </label>
          <input
            id="prop-video"
            name="video_url"
            type="url"
            className="form-control"
            placeholder="https://www.youtube.com/watch?v=…"
            value={videoUrl || ""}
            onChange={(e) => onVideoUrlChange(e.target.value)}
            disabled={mediaBusy}
          />
          <small className="form-hint">
            Необов'язково. Стандартне посилання YouTube.
          </small>
        </div>
      </div>
    </section>
  );
}

export default CreateStepMedia;
